var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircle20(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 9"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 15",
    cx: 10,
    cy: 10,
    r: 9.375,
    stroke: "#00C2FF",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 25",
    d: "M11.25 8.75L16.25 3.75",
    stroke: "#00C2FF",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1211",
    x: 8.125,
    y: 8.125,
    width: 3.75,
    height: 3.75,
    fill: "white",
    stroke: "#222627",
    strokeWidth: 1.25
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircle20);
export default __webpack_public_path__ + "static/media/circle_20.1a94c6f7c9c10a40938094ce94d43bd6.svg";
export { ForwardRef as ReactComponent };